<template>
  <div class="candidate-create">
    <ModalWindow
      v-if="showDublicateModal"
      @close="showDublicateModal = false"
      class="candidate-moda"
    >
      <CandidateDublicateAttention
        @close="showDublicateModal = false"
        @replaceSuccess="onReplaceSuccess"
      />
    </ModalWindow>
    <div class="candidate-create__wrapper container">
      <router-link to="/candidates" class="candidate-create__breadcrumbs">
        <img src="@/assets/images/icons/back-arrow.svg" alt="arrow" />
        <p>База кандидатов</p>
      </router-link>

      <div class="candidate-create__header">
        <h1 class="candidate-create__title main-title">
          {{ $route.meta.name }}
        </h1>
      </div>
      <div class="candidate-create__body">
        <div class="candidate-create__form">
          <div class="candidate-create__form-header">
            <h2 class="candidate-create__form-title">Данные кандидата</h2>
            <VSelect
              class="candidate-create__form-header-select"
              placeholder="Выберите статус"
              :options="statusOptions"
              v-model="form.status"
            />
          </div>

          <section class="candidate-create__form-section">
            <h3 class="candidate-create__form-section-title">Личные данные</h3>
            <div class="candidate-create__form-row">
              <div class="candidate-create__form-field">
                <VCustomInput
                  class="candidate-create__input"
                  placeholder="Фамилия*"
                  :error="v$.second_name.$error"
                  v-model="form.second_name"
                />
                <p
                  class="candidate-create__form-field-error"
                  v-if="v$.second_name.$error"
                >
                  Заполните обязательное поле
                </p>
              </div>
              <div class="candidate-create__form-field">
                <VCustomInput
                    class="candidate-create__input"
                    placeholder="Имя*"
                    :error="v$.first_name.$error"
                    v-model="form.first_name"
                />
                <p
                    class="candidate-create__form-field-error"
                    v-if="v$.first_name.$error"
                >
                  Заполните обязательное поле
                </p>
              </div>
            </div>
            <div class="candidate-create__form-row">
              <div class="candidate-create__form-field">
                <VCustomInput
                    class="candidate-create__input"
                    placeholder="Отчество*"
                    :error="v$.parent_name.$error"
                    v-model="form.parent_name"
                />
                <p
                    class="candidate-create__form-field-error"
                    v-if="v$.parent_name.$error"
                >
                  Заполните обязательное поле
                </p>
              </div>
              <div class="candidate-resume__form-field">
                <VSelect
                    class="candidate-resume__input"
                    placeholder="Пол*"
                    :error="v$.gender.$error"
                    :options="genderOptions"
                    v-model="form.gender"
                />
                <p
                    class="candidate-create__form-field-error"
                    v-if="v$.gender.$error"
                >
                  Заполните обязательное поле
                </p>
              </div>
            </div>
            <div class="candidate-create__form-row">
              <div class="candidate-create__form-field">
                <VCustomInput
                  class="candidate-create__input"
                  placeholder="Дата рождения*"
                  :error="v$.birthdate.$error"
                  v-model="form.birthdate"
                  v-mask="'00.00.0000'"
                />
                <p
                  class="candidate-create__form-field-error"
                  v-if="v$.birthdate.$error"
                >
                  Заполните обязательное поле
                </p>
              </div>
              <div class="candidate-create__form-field">
                <VNationalityField
                    class="candidate-resume__input"
                    placeholder="Гражданство*"
                    :error="v$.nationality.$error"
                    v-model="form.nationality"
                />
              </div>

            </div>
            <div class="candidate-create__form-field">
              <VSearchSelectCity
                  class="candidate-create__select"
                  placeholder="Город проживания*"
                  :error="v$.residence.$error"
                  @selectItem="onSelectResidence"
                  v-model="form.residence"
              />
              <p
                  class="candidate-create__form-field-error"
                  v-if="v$.residence.$error"
              >
                Заполните обязательное поле
              </p>
            </div>
          </section>
          <section class="candidate-create__form-section">
            <h3 class="candidate-create__form-section-title">
              Контактные данные
            </h3>
            <div class="candidate-create__form-row">
              <div class="candidate-create__form-field">
                <VCustomInput
                  class="candidate-create__input"
                  placeholder="Телефон*"
                  :error="v$.phone.$error || errorFromBack.phone"
                  v-model="form.phone"
                  v-mask="'+0(000) 000-00-00'"
                  type="text"
                  name="mask"
                />
                <VTextValidate
                    :error="v$.phone.$error"
                    :error-array="errorFromBack"
                    :validate-data="form.phone"
                    field-name="phone"
                />
              </div>

              <div class="candidate-create__form-field">
                <VCustomInput
                  class="candidate-create__input"
                  placeholder="Почта"
                  :error="v$.email.$error"
                  v-model="form.email"
                />
                <VTextValidate
                    :error="v$.email.$error"
                    :error-array="errorFromBack"
                    :validate-data="form.email"
                    field-name="email"
                />
              </div>
            </div>
          </section>
          <section class="candidate-create__form-section">
            <h3 class="candidate-create__form-section-title">
              Дополнительные данные
            </h3>
            <div class="candidate-create__form-row">
              <VCustomInput
                class="candidate-create__select"
                placeholder="Стаж (лет)"
                v-model="form.work_experience"
              />
              <VSelect
                class="candidate-create__select"
                placeholder="Источник"
                :id="1"
                :options="sourceOptions"
                v-model="form.source"
              />
            </div>
            <div class="candidate-create__form-row_full">
              <VTagsInputSelect
                  class="candidate-create__select"
                  placeholder="Метки"
                  :id="3"
                  :options="labelsOptions"
                  :isWithoutCheckmarks="true"
                  v-model="form.labels"
              />
            </div>
            <div class="candidate-create__form-row_full">
              <VTagsInputSelect
                class="candidate-create__select"
                placeholder="Специальности"
                :id="2"
                :options="specialitiesOptions"
                :isWithoutCheckmarks="true"
                v-model="form.specialities"
              />
            </div>

          </section>
          <section class="candidate-create__form-section">
            <h3 class="candidate-create__form-field-title">
              Файлы
            </h3>
            <VAddFiles
                v-model="form.files"
                :valueIn="documents_for_sign_in"
                style="margin-top: 0"
                set-padding="0"
            />
          </section>


          <section class="candidate-create__form-section">
            <h3 class="candidate-create__form-field-title">
              Комментарий по кандидату
            </h3>
            <p class="candidate-create__form-field-label">
              Не более 2000 символов
            </p>
            <div class="candidate-create__form-textarea">
              <VEditor
                placeholder="Напишите комментарий"
                v-model="form.comment"
                id="comment"
                class="basic-information__editor"
              />
            </div>
          </section>
        </div>
      </div>

      <ResponsibleManager v-model="form.responsible_hr" :error="v$.responsible_hr.$error"/>

      <div class="candidate-create__btns">
        <VButtonNew
          label="Отменить"
          style-type="grey"
          class="candidate-create__btn"
          link
          to="/candidates"
        />

        <VButtonNew
          label="Сохранить"
          class="candidate-create__btn"
          @click="saveCandidate"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import VTagsInputSelect from "@/components/UI/VTagsInputSelect";
import CandidateDublicateAttention from "@/components/ModalWindow/ModalBodyes/CandidateDublicateAttention";
import candidates from "@/api/candidates";
import useOffsetTop from "@/hooks/getOffsetTopScroll";
import eventBus from "@/services/eventBus";
import ResponsibleManager from "@/components/CreateVacancy/ResponsibleManager/index.vue";
import VNationalityField from "@/components/UI/DataFields/VNationalityField/index.vue";
import VAddFiles from "@/components/UI/VAddFiles.vue";
import sources from "@/api/sources";

const router = useRouter();
const route = useRoute();
const showDublicateModal = ref(false);
const showReplaceModal = ref(false);
const form = reactive({
  first_name: "",
  second_name: "",
  parent_name: "",
  gender: "",
  responsible_hr: "",
  birthdate: "",
  residence: "",
  nationality: "",
  residence_id: null,
  phone: "",
  email: "",
  specialities: "",
  work_experience: "",
  status: "",
  labels: "",
  source: "",
  comment: `<p></p>`,
  files: ""
});
const documents_for_sign_in = ref([])
const residenceValid = () => {
  if (form.residence_id && form.residence) return true;
  return false;
}
const rules = computed(() => ({
  first_name: { required },
  second_name: { required },
  parent_name: { required },
  nationality: { required },
  gender: { required },
  birthdate: { required },
  residence: { residenceValid },
  responsible_hr: { required },
  phone: { required },
  email: { email },
}));

const v$ = useVuelidate(rules, form);

const genderOptions = [
  {
    id: "male",
    label: "Мужчина",
  },
  {
    id: "female",
    label: "Женщина",
  },
];

const genderParseOptions = [
  {
    id: "male",
    label: ["Мужчина", "Мужской", "Муж", "М"],
  },
  {
    id: "female",
    label: ["Женщина", "Женский", "Жен", "Ж"],
  },
];

const statusOptions = ref([]);
const sourceOptions = ref([]);
const labelsOptions = ref([]);
const specialitiesOptions = ref([]);
const errorFromBack = ref({})

const saveCandidate = async () => {
  const validate = await v$.value.$validate();

  if (!validate) {
    useOffsetTop();
    return;
  }
  candidates.addCandidate(form).then((res) => {
    router.push(`/candidates`);
  }).catch((err) => {
    errorFromBack.value = err?.response.data.errors
    eventBus.emit("errorRequest", {
      title: "Ошибка",
      description: "Произошла ошибка при сохранении, проверьте корректность данных",
    });
  });
};

const onReplaceSuccess = () => {
  showReplaceModal.value = true;
};


const onSelectResidence = (item) => {
  form.residence_id = item?.id;
  form.residence = item?.fullDescription? item.fullDescription : item.name;
};
onMounted(async () => {
  if (route?.query) {
    form.age = route?.query?.age;
    form.work_experience = route?.query?.experience;
    form.gender = route?.query?.gender
      ? genderParseOptions.find((item) =>
          item.label.includes(route?.query?.gender)
        )?.id
      : "";
    form.source = route?.query?.source;
    form.specialities = route?.query?.specialities
      ? Array.from(new Set(route?.query?.specialities.split(",")))
      : [];
    const birthdate = route?.query?.age
      ? new Date(
          Date.now() - Number(route?.query?.age) * 1000 * 60 * 60 * 24 * 365
        )
      : null;
    form.birthdate = birthdate && `01.01.${birthdate.getFullYear()}`;
  }
  candidates.getStatuses().then((res) => {
    statusOptions.value = res?.data?.statuses?.map((option, index) => ({
      id: option,
      label: option,
    }));
  });

  sourceOptions.value = await sources.getSources()
  sourceOptions.value = sourceOptions.value?.map((option, index) => ({
    id: option.name,
    label: option.name,
  }))

  candidates.getLabels().then((res) => {
    labelsOptions.value = res?.data?.labels;
  });

  candidates.getSpecialities().then((res) => {
    specialitiesOptions.value = res?.data?.specialities;
  });

});
</script>

<style scoped lang="scss">
.candidate-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 40px 24px 24px;

  &__close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }

  &__icon {
    height: 56px;
    width: 56px;
    flex: 0 0 auto;
    align-self: center;
    margin-bottom: 16px;
  }

  &__title {
    margin-bottom: 8px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    line-height: 24.2px;
  }

  &__comment {
    margin-bottom: 24px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 20.8px;
  }
  &__button {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
}

.candidate-create {
  padding-bottom: 45px;
  :deep(.modal__body) {
    width: 352px;
  }

  :deep(.v-filtration) {
    border-radius: 4px;
    background-color: $light;
  }
  :deep(.v-filtration__filter) {
    width: 186px;
    border-radius: 4px;
  }

  &__wrapper {
    padding-top: 14px;
  }

  &__breadcrumbs {
    display: flex;
    align-items: center;
    color: $gray;
    text-decoration: none;
    cursor: pointer;
    user-select: none;

    p {
      margin-left: 4px;
      font-size: 14px;
      font-weight: 400;
    }

    img {
      width: 20px;
    }
  }

  &__header {
    margin-top: 8px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__switch {
    :deep(.v-filtration__label) {
      font-weight: 400;
    }
  }

  &__form {
    padding: 24px;
    background-color: #fff;
    border-radius: 16px;
  }

  &__form-header {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #e4e7ee;
  }

  &__form-header-select {
    flex: 0 1 224px;
    :deep(.v-select__header) {
      width: 224px;
      height: 44px;
      background-color: #f0f2f4;
    }
    :deep(.v-select__header-palceholder) {
      color: $gray;
    }
    :deep(.v-select__header_selected .v-select__header-palceholder) {
      display: none;
    }

    :deep(.v-select__header_selected .v-select__header-value) {
      top: 16px;
    }
  }

  &__form-title {
    flex: 1 1 50%;
    font-size: 20px;
    font-weight: 500;
  }
  &__form-section {
    margin-top: 20px;
  }
  &__form-section-title {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    line-height: 19.36px;
    text-align: left;
  }

  &__input {
    width: 100%;
  }

  &__form-field {
    :deep(.v-input) {
      width: 100%;
    }

    :deep(.manager-field__form-field-error) {
      margin-top: 12px;
    }
  }

  &__form-field-error {
    margin-top: 4px;
    font-size: 14px;
    color: $red;
  }

  &__form-field-title {
    margin-bottom: 4px;
    font-size: 16px;
    font-weight: 500;
    line-height: 19.36px;
    text-align: left;
  }

  &__form-field-label {
    margin-bottom: 16px;
    color: $gray;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
  }

  &__form-textarea {
    :deep(.v-editor__editor) {
      height: 240px;
    }
  }

  &__form-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
    & div {
      flex: 0 1 calc(50% - 8px);
    }
    &_full {
      margin-bottom: 16px;
    }
  }

  &__btns {
    width: 100%;
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
  }

  &__btn {
    &:first-child {
      width: 42.307%;
    }

    &:last-child {
      width: 53.846%;
    }
  }
}
</style>
